import { Alert } from '@creditornot/cb-alert';
import { Button } from '@creditornot/cb-button';
import { ModalHeader, ModalContent, ModalFooter } from '@creditornot/cbt-modal';
import React, { ReactNode } from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { WoltModal } from 'common/components';
import sendErrorReport from 'common/utils/sendErrorReport';

const Root = styled(WoltModal)`
  width: 100%;
  max-width: 500px;
`;

const Content = styled(ModalContent)``;

const ContactSupport = styled.div`
  margin-block-start: 24px;
`;

const ErrorBoundary = ({ children }: { children: ReactNode }) => (
  <ReactErrorBoundary
    onError={(error, info) => {
      sendErrorReport(error, 'boundary', { info });
    }}
    FallbackComponent={({ error }) => (
      <Root isOpen>
        <ModalHeader>
          <FormattedMessage id="global-error-message.header" />
        </ModalHeader>
        <Content>
          <Alert variant="error">
            {error instanceof Error ? error.message : <FormattedMessage id="global-error-message.unknown-error" />}
          </Alert>
          <ContactSupport>
            <FormattedMessage id="global-error-message.contact-support-prompt" />
          </ContactSupport>
        </Content>
        <ModalFooter>
          <Button
            size="small"
            onClick={() => {
              location.reload();
            }}
            variant="primary"
          >
            <FormattedMessage id="global-error-message.refresh-page" />
          </Button>
        </ModalFooter>
      </Root>
    )}
  >
    {children}
  </ReactErrorBoundary>
);

export default ErrorBoundary;
